import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Retailers from "@/pages/Retailers";
import Orders from "@/pages/Orders";
import MaterialPicking from "@/pages/MaterialPicking";
import Scanning from "@/pages/Scanning";
import Packing from "@/pages/Packing";
import Dispatch from "@/pages/Dispatch";
import Support from "@/pages/Support";
import BoxNotes from "@/pages/BoxNotes";
import Returns from "@/pages/Returns";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Purchase from "@/pages/Purchase";
import GRSR from "@/pages/GRSR";
import RetailerVisits from "@/pages/RetailerVisits";
import ChangePassword from "@/pages/ChangePassword";
import AdminConsole from "@/pages/AdminConsole";
import SuperuserRoute from "@/components/SuperuserRoute";
import PrintDispatchLabel from "@/pages/PrintDispatchLabel";
import PrintGRSRLabel from "@/pages/PrintGRSRLabel";
import Transporters from "@/pages/Transporters";
import SalesFile from "@/pages/SalesFile";
import PipelineReport from "@/pages/PipelineReport";
import PrintBoxLabel from "@/pages/PrintBoxLabel";
import AdminNotes from "@/pages/AdminNotes";
import Documents from "@/pages/Documents";
import NotFound from "@/pages/NotFound";

import "@/App.css";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin-console" element={<SuperuserRoute><AdminConsole /></SuperuserRoute>} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/companies" element={<ProtectedRoute roles={[]}><Companies /></ProtectedRoute>} />
            <Route path="/retailers" element={<ProtectedRoute roles={["accounts"]}><Retailers /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute roles={["accounts","salesman"]}><Orders /></ProtectedRoute>} />
            <Route path="/picking" element={<ProtectedRoute roles={["picker"]}><MaterialPicking /></ProtectedRoute>} />
            <Route path="/scanning" element={<ProtectedRoute roles={["scanner"]}><Scanning /></ProtectedRoute>} />
            <Route path="/packing" element={<ProtectedRoute roles={["packer"]}><Packing /></ProtectedRoute>} />
            <Route path="/dispatch" element={<ProtectedRoute roles={["accounts"]}><Dispatch /></ProtectedRoute>} />
            <Route path="/print-label" element={<ProtectedRoute roles={["accounts"]}><PrintDispatchLabel /></ProtectedRoute>} />
            <Route path="/print-grsr-label" element={<ProtectedRoute roles={["accounts"]}><PrintGRSRLabel /></ProtectedRoute>} />
            <Route path="/transporters" element={<ProtectedRoute roles={["accounts"]}><Transporters /></ProtectedRoute>} />
            <Route path="/sales-file" element={<ProtectedRoute roles={["accounts"]}><SalesFile /></ProtectedRoute>} />
            <Route path="/pipeline-report/:kind" element={<ProtectedRoute><PipelineReport /></ProtectedRoute>} />
            <Route path="/print-box-label" element={<ProtectedRoute roles={[]}><PrintBoxLabel /></ProtectedRoute>} />
            <Route path="/admin-notes" element={<ProtectedRoute roles={[]}><AdminNotes /></ProtectedRoute>} />
            <Route path="/support" element={<Support />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/box-notes" element={<ProtectedRoute roles={["accounts"]}><BoxNotes /></ProtectedRoute>} />
            <Route path="/returns" element={<ProtectedRoute roles={[]}><Returns /></ProtectedRoute>} />
            <Route path="/purchases" element={<ProtectedRoute roles={[]}><Purchase /></ProtectedRoute>} />
            <Route path="/grsr" element={<ProtectedRoute roles={["accounts"]}><GRSR /></ProtectedRoute>} />
            <Route path="/visits" element={<ProtectedRoute roles={["collection"]}><RetailerVisits /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={[]}><Users /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute roles={["accounts"]}><Reports /></ProtectedRoute>} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
